import { render, staticRenderFns } from "./News.vue?vue&type=template&id=c2337990&scoped=true&"
var script = {}
import style0 from "./News.vue?vue&type=style&index=0&id=c2337990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2337990",
  null
  
)

export default component.exports